/**
 * useHeadwayCv — polls /api/metrics/headway_cv every 6s.
 * Backend caches at 3s so this doesn't hammer the vehicle feed.
 */
import { useEffect, useState } from "react";
import { getBaseUrl } from "../lib/api";
export function useHeadwayCv(intervalMs = 6_000) {
    const [data, setData] = useState(null);
    useEffect(() => {
        let cancelled = false;
        const load = () => fetch(`${getBaseUrl()}/api/metrics/headway_cv`)
            .then((r) => (r.ok ? r.json() : null))
            .then((j) => {
            if (!cancelled && j)
                setData(j);
        })
            .catch(() => {
            /* transient — keep the last value */
        });
        void load();
        const t = window.setInterval(load, intervalMs);
        return () => {
            cancelled = true;
            window.clearInterval(t);
        };
    }, [intervalMs]);
    return data;
}
